import { update_window_type } from '../../redux/Slice/windowTypeSlice';
import {
  setHotspotBillboardEnabled,
  syncHotspotDesignQuaternion,
  syncHotspotsForPreviewMode,
} from '../../components/gridpagefunction/HotSpot';
import store from '../../redux/store';
import { sceneStateHelper } from '../ThreeJsUtils/SceneStateHelper';
import { replayPreviewMode } from './replayPreviewMode';

const getHotspotList = () =>
  store.getState().assets_object?.sceneHotspots || [];

const applyHotspotBillboard = (enabled) => {
  const hotspotList = getHotspotList();
  hotspotList.forEach((hp) => {
    try {
      setHotspotBillboardEnabled(hp, enabled);
    } catch (_) {}
  });
};

/**
 * Same steps as TabContainer preview tab click: save state, switch window type,
 * hide helpers, replay media/animations, enable hotspot billboards.
 */
export function enterPreviewMode({
  dispatch,
  scene,
  currentWindowType,
  completeObject,
  handleReplay,
  startAllAnimations,
}) {
  const currentScene = scene || completeObject?.scene;
  if (!currentScene) return;

  if (currentWindowType === 'design') {
    getHotspotList().forEach((hp) => {
      try {
        syncHotspotDesignQuaternion(hp);
      } catch (_) {}
    });
    sceneStateHelper.saveStates(currentScene);
  }

  dispatch(
    update_window_type({
      type: 'preview',
      current_type: currentWindowType,
      scene: currentScene,
    })
  );

  if (completeObject?.showCameraHelper) {
    completeObject.showCameraHelper(false);
  }

  if (handleReplay) {
    handleReplay();
  } else {
    replayPreviewMode({
      scene: currentScene,
      stopAllAnimations: completeObject?.stopAllAnimations,
      startAllAnimations:
        startAllAnimations || completeObject?.restartAnimations,
      renderer: completeObject?.renderer || completeObject?.rendererNew,
      camera: completeObject?.camera,
    });
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      applyHotspotBillboard(true);
      const renderer =
        completeObject?.renderer || completeObject?.rendererNew || null;
      const camera = completeObject?.camera || null;
      syncHotspotsForPreviewMode(getHotspotList(), camera, renderer);
    });
  });
}
